import Dashboard from '../containers/dashboard'
import CustomersManagement from '../containers/customers-management'

const Customers = () => {
  return (
    <Dashboard>
      <CustomersManagement />
    </Dashboard>
  )
}

export default Customers
